import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule} from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AgGridModule } from "ag-grid-angular";
import { NgxSpinnerModule } from "ngx-spinner";

import {BadgeModule} from 'primeng/badge';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {ButtonModule} from 'primeng/button';
import {CalendarModule} from 'primeng/calendar';
import {DividerModule} from 'primeng/divider';
import {DialogModule} from 'primeng/dialog';
import {DropdownModule} from 'primeng/dropdown';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {FieldsetModule} from 'primeng/fieldset';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputTextModule} from 'primeng/inputtext';
import {ListboxModule} from 'primeng/listbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {ToastModule} from 'primeng/toast';
import {ToolbarModule} from 'primeng/toolbar';

import { AuthGuardService } from "../services/auth-guard.service";
import { EmployeeRosterFormComponent } from "./employee-roster-form.component";
import { RosterComponent } from "./roster.component";
import { InputTextareaModule } from "primeng/inputtextarea";
import { RosterTooltipComponent } from "./roster-tooltip.component";
import { PanelModule } from "primeng/panel";
import { SharedModule } from "../shared/shared.module";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { UpdateTravelStatusFormComponent } from "./update-travel-status-form.component";
import { EmployeeFilterComponent } from "./employee-filter.component";
import { EmployeeFloatingFilterComponent } from "./employee-floating-filter.component";
import { EmployeeModule } from "../employees/employee.module";
import { EmployeeNameRenderer } from "./employee-name-renderer.component";
import { SidebarModule } from "primeng/sidebar";
import { InvalidEmployeeRostersComponent } from "./invalid-employee-rosters.component";
import { TableModule } from "primeng/table";
import { CheckboxModule } from "primeng/checkbox";
import { MessagesModule } from "primeng/messages";
import { DeleteRosterDataFormComponent } from "./delete-roster-data-form.component";
import { RosterEmployeeNoteFormComponent } from "./roster-employee-note-form.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    SharedModule,
    AgGridModule.withComponents([RosterTooltipComponent]),

    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CalendarModule,
    CheckboxModule,
    ConfirmDialogModule,
    DialogModule,
    DividerModule,
    DropdownModule,
    DynamicDialogModule,
    FieldsetModule,
    InputNumberModule,
    InputTextModule,
    InputTextareaModule,
    ListboxModule,
    MessagesModule,
    MultiSelectModule,
    PanelModule,
    SidebarModule,
    TableModule,
    ToastModule,
    ToolbarModule,
    
    RouterModule.forChild([
      { path: 'roster', component: RosterComponent, canActivate: [AuthGuardService] }
    ]),

    EmployeeModule
  ],
  declarations: [
    EmployeeRosterFormComponent,
    RosterComponent,
    RosterTooltipComponent,
    UpdateTravelStatusFormComponent,
    EmployeeFilterComponent,
    EmployeeFloatingFilterComponent,
    EmployeeNameRenderer,
    InvalidEmployeeRostersComponent,
    DeleteRosterDataFormComponent,
    RosterEmployeeNoteFormComponent
  ]
})
export class RosterModule{}